var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6429",
    "data-name": "Groupe 6429",
    transform: "translate(-1495.861 -622.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    transform: "translate(1495.861 622.86)",
    fill: "#f4deff",
    stroke: "#956ae1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6429-2",
    "data-name": "Groupe 6429",
    transform: "translate(1523.719 650.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5685",
    "data-name": "Trac\\xE9 5685",
    d: "M172.111,124.524a1.9,1.9,0,0,0,2.689,0l10.082-10.083a1.9,1.9,0,0,0-2.689-2.689l-6.836,6.836V98.3a1.9,1.9,0,1,0-3.8,0v20.287l-6.836-6.836a1.9,1.9,0,0,0-2.689,2.689Z",
    transform: "translate(-153.222 -96.4)",
    fill: "#956ae1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5686",
    "data-name": "Trac\\xE9 5686",
    d: "M134.968,385.6H98.3a1.9,1.9,0,1,0,0,3.8h36.665a1.9,1.9,0,1,0,0-3.8",
    transform: "translate(-96.402 -348.937)",
    fill: "#956ae1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.c6052206e0259ba5d7bf59de69e3cb42.svg";
export { ForwardRef as ReactComponent };